
import React from 'react';
import "./endorsements.css"


const Endorsements = () => {
  return (
    <div className='page-basics'>
      <h2>ENDORSEMENTS</h2>



      <p className='blockquote' >
        "She has an informed strategic vision and the ability to follow through by taking the necessary action. Ann is an integral member of our Executive Team.
        Not only is she a team player, she showed herself to be a competent, creative, and knowledgeable executive."
      </p>


      Prof. Chris Scott (former Chairman): The Arthritis Foundation of South Africa
      Head of Department: Paediatric Rheumatology, Red Cross Children's Hospital


      <hr />

      <p className='blockquote' >"I always was deeply impressed by her dedication to supporting students and alumni.
        She makes professional careers as well as personal lives happen like no one else I had met!"
      </p>

      Prof. Josef Strobl: The University of Salzburg, Chairman of the Board: UNIGIS International Network
      <hr />

      <p className='blockquote' >"Ann's strength lies in her fearless pursuit of excellence and understanding of the value of team-building
        in any arena whilst being mindful of each individual player.
        As my Chief at the Foundation, she is generous with her advice and guidance which fosters personal growth and achieving the desired outcomes.
        What's more, no-one can deny that she is a planner and organiser of note!  "You'll be on your way up! You'll be seeing great sights!
        You'll join the high fliers who soar to high heights."- Dr Seuss
        <br />
        Go well, Chief." </p>

      Ms V (Vicki Sanan):  Arthritis Foundation of SA; Community Liaison Officer (Eastern Cape)
      <hr />

      <p className='blockquote' >"Any student who has themselves under your wing will only succeed in the future."
      </p>


      Clayton Fourie: ESKOM
      <hr />

      <p className='blockquote' >"Ann, it was an honor having you as my advisor throughout my studies.
        You have truly guided and advised me so well – thank you so much. I'm going to miss our interaction."
      </p>

      Gisela van Zyl: ZZ2
      <hr />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />


    </div >

  );
};

export default Endorsements;